export { default } from './TypographyLink';
